module.exports = __webpack_public_path__ + "static/media/fall.80621904.jpg";